import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Container,
  Form,
  InputGroup,
  FormControl,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import parse from "html-react-parser";
import * as PageRoutes from "../../utils/route_pages";
import * as Assets from "../../utils/svg_assets";
import { isNumeric } from "../../utils/utilities";
import { InformationDialog } from "../../components/DialogCollection";
import { Base } from "../../components/RootLayout";
import { setLocalStorage } from "../../utils/utilities";
import ApiUtils from "../../utils/api_utils";
import "./style.scss";

const initPayload = {
  username: "",
  password: "",
};

const defaultErrorMessage = "<span>Email and password are mandatory</span><br>";
const tryAgain = "<span>Please try again!</span>";

const LoginPage = (props) => {
  const { loginTokenAuth, getDataOrgBySlug, orgData = {} } = props;
  const { slug } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [payload, setPayload] = useState(initPayload);
  const [errState, setErrState] = useState({
    isError: false,
    message: "",
  });
  const [passwordType, setPasswordType] = useState("password");
  const [iconPassword, setIconPassword] = useState(Assets.iconEye);
  const [isFocus, setIsFocus] = useState(false);

  const [success, setIsSuccess] = useState({
    isOpen: false,
    data: {
      features: 1,
      redirect: 1,
      show_main_menu: true,
    },
  });
  const [isAgree, setIsAgree] = useState(false);

  useEffect(() => {
    if (slug) {
      setLocalStorage("slug", slug);
      getDataOrgBySlug(slug).then((response) => {
        if (response.status === 200) {
          setDynamicTitleAndFavicon(response.data);
          setStyle(response.data);
          setLocalStorage("orgData", JSON.stringify(response.data));
        }
      });
    } else {
      dispatch.LoginSM.setLoginData({ orgData: {} });
      localStorage.removeItem("orgData");
      localStorage.removeItem("slug");
      setDynamicTitleAndFavicon(null);
      setStyle({});
    }
  }, []);

  useEffect(() => {
    setIconPassword(
      passwordType === "password" ? Assets.iconEye : Assets.iconEyeActive
    );
  }, [passwordType]);

  const setDynamicTitleAndFavicon = (retrievedObjectOrg) => {
    const faviconEl = document.getElementById("favicon");

    let data = {
      title: "SKOR",
      favicon: `${process.env.PUBLIC_URL}/favicon.ico`,
    };

    if (retrievedObjectOrg) {
      const { favicon, name } = retrievedObjectOrg;
      data.title = name;
      data.favicon = favicon;
    }

    document.title = data.title;
    faviconEl.href = retrievedObjectOrg
      ? ApiUtils.validateImgUrl({
          url: data.favicon,
        })
      : data.favicon;
  };

  const setStyle = (data) => {
    const style = document.createElement("style");
    style.textContent = `
      :root {
        --main-color: ${
          Object.keys(data).length > 0 ? data.theme_color : "#FF5829"
        };
      }
    `;
    document.head.appendChild(style);
  };

  const processLogin = async () => {
    if (payload.username && payload.password) {
      await loginTokenAuth(payload).then(function (result) {
        if (result.status === 200) {
          setIsSuccess({
            isOpen: true,
            data: result.data,
          });
        } else {
          let message = "";
          Object.keys(result.message).forEach((key) => {
            message += `<span>${isNumeric("" + key) ? "" : key} ${
              result.message[key]
            }</span> <br/>`;
          });
          message += tryAgain;
          setErrState({
            isError: true,
            message: message,
          });
        }
      });
    } else {
      setErrState({
        isError: true,
        message: `${defaultErrorMessage} ${tryAgain}`,
      });
    }
  };

  return (
    <Base>
      <Container className="px-4">
        {Object.keys(orgData).length > 0 ? (
          <div>
            {Object.keys(orgData).length > 0 && orgData.use_icon ? (
              <img
                src={
                  Object.keys(orgData).length > 0
                    ? ApiUtils.validateImgUrl({
                        url: orgData.organization_icon,
                      })
                    : Assets.logo
                }
                alt="logo"
                className="logo"
              />
            ) : Object.keys(orgData).length > 0 ? (
              <div className="logo">
                <h1>{orgData.name}</h1>
              </div>
            ) : (
              <img src={Assets.logo} alt="logo" className="logo" />
            )}
          </div>
        ) : (
          <div className="logo"></div>
        )}
        <div className="title">
          <Form.Label>
            <h3>Welcome</h3>
          </Form.Label>
          <br />
          {!errState.isError ? (
            <Form.Label className="title-text">
              Please, Login to Continue.
            </Form.Label>
          ) : (
            <Form.Label className="title-text-error">
              {parse(errState.message)}
            </Form.Label>
          )}
        </div>
        <Form>
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Email / Phone</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Email / Phone"
                className="form-control-without-border"
                value={payload.username}
                onChange={(e) => {
                  setPayload({ ...payload, username: e.target.value });
                }}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Password</Form.Label>
              <InputGroup
                className={`mb-3 password form-control-without-border
                  ${isFocus ? "active" : ""}
                  `}
              >
                <FormControl
                  className="input-password border-0 form-control-without-border"
                  type={passwordType}
                  placeholder="Enter Password"
                  value={payload.password}
                  onFocus={() => {
                    setIsFocus(true);
                  }}
                  onBlur={() => {
                    setIsFocus(false);
                  }}
                  onChange={(e) => {
                    setPayload({ ...payload, password: e.target.value });
                  }}
                />
                <img
                  src={iconPassword}
                  className="icon-view"
                  onClick={() => {
                    setPasswordType(
                      passwordType === "password" ? "text" : "password"
                    );
                  }}
                  alt="eye"
                />
              </InputGroup>
            </Form.Group>
          </Row>
          <Row>
            <Col>
              Forgot Password?{" "}
              <NavLink to={PageRoutes.forgotPassword} className="link-forget">
                tap here
              </NavLink>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={1} sm={1} md={1}>
              <Form.Check
                aria-label="option 1"
                value={isAgree}
                onClick={() => setIsAgree(!isAgree)}
              />
            </Col>
            <Col xs={10} sm={10} md={10}>
              I agree to{" "}
              <NavLink
                className="link-forget"
                to={PageRoutes.terms_and_condition}
              >
                {" "}
                terms and condition
              </NavLink>{" "}
              and
              <br />
              <NavLink className="link-forget" to={PageRoutes.privacy_policy}>
                {" "}
                privacy policy
              </NavLink>
            </Col>
          </Row>
          <br />
          <Row>
            <Button
              disabled={isAgree ? false : true}
              variant="danger"
              className="btn-login"
              onClick={processLogin}
            >
              {" "}
              Login{" "}
            </Button>
          </Row>
          <Row className="mt-5">
            <div className="d-flex align-items-center">
              <span className="mr-xs">Powered by</span>
              <img
                src={Assets.logo}
                alt="logo skor"
                className="w-logo-footer"
              />
            </div>
          </Row>
        </Form>
        <InformationDialog
          message="Login Success"
          closeLabel="OK"
          show={success.isOpen}
          onHide={() => {
            switch (success.data.redirect) {
              case 3:
                navigate(PageRoutes.reward, { replace: true });
                break;
              default:
                navigate(PageRoutes.home, { replace: true });
                break;
            }
          }}
        />
      </Container>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  profile: state.LoginSM.login,
  orgData: state.LoginSM.orgData,
});

const mapDispatchToProps = (dispatch) => ({
  loginTokenAuth: dispatch.LoginSM.loginTokenAuth,
  getDataOrgBySlug: dispatch.LoginSM.getDataOrgBySlug,
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
